import brandTheme from '../../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

const styles = {
  benefits: {
    fontWeight: 400,
    fontSize: 16,
    color: '#00112B',
    marginBottom: 24,
    width: '100%',
  },
  benefitsItem: {
    display: 'flex',
    alignItems: 'center',
    '&:first-child': {
      marginRight: 34,
    },
    '& span': {
      marginLeft: 10,
    },
  },
  listIcon: {
    color: colors.primary,
    width: 18,
    height: 18,
  },
  listText: {
    '& span': {
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      lineHeight: 1.5,
      fontSize: 16,
    },
  },
  industrySelect: {
    maxHeight: 330,
  },
  logIn: {
    marginTop: 16,
    fontSize: 16,
    '& a': {
      fontSize: 16,
      color: colors.primary,
    },
  },
  link: {
    color: colors.primary,
    fontSize: 16,
    cursor: 'pointer',
  },
  progressBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '24px',
  },
}

export default styles
